import styled from 'styled-components';
import { A } from '../../shared/components/A';
import { Grey } from '@pegasus/ui-constants/colors';
import { spacingUnits } from '@pegasus/ui-constants/spacing';
import { Screen, screenFrom } from '@pegasus/ui-constants/breakpoints';

export const Wrapper = styled.div<{ isLegacy?: boolean }>`
    background: white;
    display: flex;
    flex-direction: column;
    width: 25%;
    padding: ${spacingUnits(6)} 0;
    display: none;
    ${({ isLegacy }) => (isLegacy ? screenFrom(Screen.tablet) : screenFrom(Screen.desktop))} {
        min-width: 220px;
        display: block;
    }
`;
export const Header = styled.div`
    font-weight: bold;
    font-size: 24px;
    line-height: 32px;
    display: flex;
    color: #353535;
    margin: 0 27px;
`;
export const List = styled.ul`
    display: flex;
    flex-direction: column;
    list-style: none;
    padding: 0;
`;

interface ItemProps {
    highlighted: boolean;
}

export const Item = styled(A)<ItemProps>`
    padding: ${spacingUnits(2)} ${spacingUnits(10)};
    background: ${(props: ItemProps) => (props.highlighted ? '#353535' : 'transparent')};
    color: ${(props: ItemProps) => (props.highlighted ? 'white' : '#353535')};
    text-decoration: none;
    :hover {
        background: ${(props: ItemProps) => (props.highlighted ? '#353535' : Grey.light)};
        color: ${(props: ItemProps) => (props.highlighted ? 'white' : Grey.dark)};
    }
`;

export const HR = styled.div`
    height: 1px;
    width: 90%;
    border-bottom: 1px solid #c4c4c4;
    margin: ${spacingUnits(2)} auto ${spacingUnits(4)} auto;
`;

export const ItemTitle = styled.div`
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.5px;
    color: inherit;
`;
